:host {
  display: block;
  position: relative;
  width: calc(100% - 1px) !important;
}

$horizontal_padding: calc(7 * var(--spacer));
$container_padding_top: calc(5 * var(--spacer));
$container_padding_bottom: calc(4 * var(--spacer));

.card {
  &--wrapper {
    height: 100%;
  }
  &--tag {
    position: absolute;
    top: 0;
    left: 0;
    font-family: var(--font-family-secondary-mono);
    font-size: 12px;
    font-weight: 500;
    padding: 0 var(--spacer);
    background-color: var(--main-titles-inputs-601);
    color: var(--white-layout-300-primary);
    text-transform: uppercase;
    border-top-left-radius: 4px;
  }
  &--content {
    padding: $container_padding_top $horizontal_padding 0;
    flex: 1;
  }
  &--footer {
    padding: 0 0 $container_padding_bottom $horizontal_padding;
  }
  &--title {
    margin-bottom: calc(2 * var(--spacer));
    color: var(--body-text-arrows-400);
  }
  &--intro {
    margin-bottom: calc(4.5 * var(--spacer));
    color: var(--body-text-arrows-400);
  }
  &--image {
    height: 223px;
    width: 100%;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background-size: cover;
    background-repeat: no-repeat;
  }
}

gz-text span {
  font-family: var(--font-family-secondary);
  font-size: var(--body-size-large);
}

:host([cardColor='primary']) {
  gz-title,
  gz-text {
    color: var(--white-layout-300-primary);
  }

  .card {
    &--wrapper {
      background-color: var(--blue-layout-403-primary);
      color: var(--white-layout-300-primary);
    }
    &--image {
      width: calc(100% - calc(2 * $horizontal_padding));
      height: 175px;
      margin-top: calc(6 * var(--spacer));
      margin-left: auto;
      margin-right: auto;
    }
  }
}
